import React, { useEffect, useState } from "react"
import { Box, FormGroup, FormControlLabel, Switch } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { useDispatch, useSelector } from "react-redux"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormControlLabel-label": {
			fontSize: theme.typography.fontSize,
			fontWeight: theme.typography.fontWeightRegular,
			marginRight: 4,
		},
	},
}))

const BlueSwitch = withStyles((theme) => ({
	switchBase: {
		color: theme.palette.common.white,
		"&$checked": {
			color: theme.palette.primary.dark,
		},
		"&$checked + $track": {
			backgroundColor: theme.palette.primary.dark,
		},
	},
	checked: {},
	track: {},
}))(Switch)

export default function TableViewSwitch(props) {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles(theme)
	const dispatch = useDispatch()
	const { showDuplicate } = useSelector((state) => state.filter)

	const { isTableView, setIsTableView } = props

	const handleChange = (event) => {
		console.log("View Switched", event.target.checked)
		//dispatch(resetSelectedIdsAction())
		//dispatch(showDuplicateAction({ data: event.target.checked ? false : true }))
		setIsTableView(event.target.checked)
	}

	return (
		<Box mr={2} style={{ alignContent: "end" }}>
			<FormGroup className={classes.root}>
				<FormControlLabel
					control={<BlueSwitch size="small" checked={isTableView} onChange={handleChange} name="tableView" />}
					label={t("dashboard.tableView")}
					labelPlacement="start"
				/>
			</FormGroup>
		</Box>
	)
}
